// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_lHW","col":"styles_col__QaEJR","actions":"styles_actions__1Dcd8","conflict":"styles_conflict__2ep53"};